/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 11/05/22
 */

import Icons from '@/components/icons/Icons';
import { Tooltip } from '@chakra-ui/react';
import React from 'react';

interface InlineHelpBubbleProps {
    label: string;
    id?: string;
}

const InlineHelpBubble = ({ label, id }: InlineHelpBubbleProps) => {
    return (
        <Tooltip label={label} placement="right" fontSize="md">
            <Icons.FAQIcon
                id={id}
                aria-label={label}
                w="1.75em"
                h="1.75em"
                marginLeft={2}
                alignSelf="center"
                tabIndex={0}
                borderRadius={'50%'}
                __css={{
                    outlineColor: 'transparent',
                    outlineStyle: 'solid',
                    outlineWidth: 2,
                    outlineOffset: 0,
                    transition: 'outline-color 0.25s',
                    _focus: {
                        boxShadow: 'none',
                        outlineColor: 'blue',
                    },
                }}
            />
        </Tooltip>
    );
};

export default InlineHelpBubble;
